<div class="insurance-list-title">
    <h3 [ngSwitch]="purchasedProduct.productId">
        {{ purchasedProduct.product.productDescription | capitalize }}
        <ng-container *ngSwitchCase="productIdEnum.Car">
            <span class="insurance-list-title__subtitle">
                {{ purchasedProduct.product.car.motorVehicleMake | capitalize }}
                {{ purchasedProduct.product.car.motorVehicleType | capitalize }}
                {{ purchasedProduct.product.car.licensePlate | kenteken }}
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="productIdEnum.Moped">
            <span class="insurance-list-title__subtitle">
                {{ purchasedProduct.product.moped.motorVehicleMake | capitalize }}
                {{ purchasedProduct.product.moped.motorVehicleType | capitalize }}
                {{ purchasedProduct.product.moped.licensePlate | kenteken }}
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="productIdEnum.Bicycle">
            <span class="insurance-list-title__subtitle">
                {{ purchasedProduct.product.bicycle.bicycleBrand }} {{ purchasedProduct.product.bicycle.framenumber }}
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="productIdEnum.Caravan">
            <span class="insurance-list-title__subtitle">
                {{ purchasedProduct.product.caravan.caravanBrand | capitalize }}
                {{ purchasedProduct.product.caravan.caravanModel | capitalize }}
                {{ purchasedProduct.product.caravan.licensePlate | kenteken }}
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="productIdEnum.Pet">
            <!-- Only show breed description if it is not unknown -->
            <span
                class="insurance-list-title__subtitle"
                *ngIf="
                    purchasedProduct.product.pet.breedId === CAT_BREED_UNKNOWN ||
                    purchasedProduct.product.pet.breedId === DOG_BREED_UNKNOWN
                "
            >
                {{ purchasedProduct.product.pet.petName }}
            </span>
            <span
                class="insurance-list-title__subtitle"
                *ngIf="
                    purchasedProduct.product.pet.breedId !== CAT_BREED_UNKNOWN &&
                    purchasedProduct.product.pet.breedId !== DOG_BREED_UNKNOWN
                "
            >
                {{ purchasedProduct.product.pet.breedDescription | capitalize }}
                {{ purchasedProduct.product.pet.petName }}
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="productIdEnum.Motorcycle">
            <span class="insurance-list-title__subtitle">
                {{ purchasedProduct.product.motorcycle.motorVehicleMake | capitalize }}
                {{ purchasedProduct.product.motorcycle.motorVehicleType | capitalize }}
                {{ purchasedProduct.product.motorcycle.licensePlate | kenteken }}
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="productIdEnum.Home">
            <span class="insurance-list-title__subtitle insurance-list-title__subtitle--mobile">
                {{ purchasedProduct.product.home.postalCode }} {{ purchasedProduct.product.home.civicNumber }}
            </span>
            <span class="insurance-list-title__subtitle insurance-list-title__subtitle--desktop">
                {{ fullAddressAsString() }}
            </span>
        </ng-container>
    </h3>
</div>
